export const calendarsReducer = (state = {loading: true, resultcalendar: null, calendars: null, calendar: null } , action) => {
    switch (action.type) {
        case 'CALENDAR_GETALL_SUCCESS':
            return {
                ...state,
                loading: false,
                calendars: action.payload
            }
        case 'CALENDAR_ADD_SUCCESS':
            return {
                ...state,
                loading:false,
                resultcalendar: action.payload
            }
        case 'CALENDAR_EDIT_SUCCESS':
            return {
                ...state,
                loading:false,
                resultcalendar: action.payload
            }
        case 'CALENDAR_RESET_RESULT':
            return {
                ...state,
                resultcalendar: null
            }
        case 'CALENDAR_LOADING':
            return {
                ...state,
                loading:true
            }
        case 'CALENDAR_NOT_LOADING':
            return {
                ...state,
                loading:false
            }
        default:
            return state
    }
}

